import { render, staticRenderFns } from "./GeneralStep.vue?vue&type=template&id=fc155ce2&scoped=true&"
import script from "./GeneralStep.vue?vue&type=script&lang=js&"
export * from "./GeneralStep.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStep.vue?vue&type=style&index=0&id=fc155ce2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc155ce2",
  null
  
)

export default component.exports